import React, { ChangeEvent } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { useKSK2020_R01Store } from '../Store_KSK2020_R01';
import { KioskFormTitle } from 'src/components/common/form/KioskFormTitle';
import { InfoFieldHandlers } from 'src/types/info-form';
import { useDescText } from 'src/hooks/useDescText';
import { DESC_BTN, DESC_FLD } from 'src/utils/descLanguage/descLanguageUtil';

interface Props {
	setSearchTrigger: (value: boolean) => void;
	handleChange: (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => void;
	handleFetchLotList: () => void;

	getProductWorkFieldHandlers: (fieldName: string) => InfoFieldHandlers;
	titleWidth?: number;
}

export const InputForm_KSK2020_R01 = (props: Props) => {

	const {
		setSearchTrigger,
		handleChange,
		getProductWorkFieldHandlers,
		titleWidth,
	} = props;

	const {
		editKSK2020_R01,
	} = useKSK2020_R01Store();
	const { renderDescText } = useDescText();

	return (
		<div className="mb-[7px] w-full flex items-center gap-[6px]">
			<label className="flex h-[38px] min-w-0 flex-1 items-center">
				<KioskFormTitle
					title={renderDescText(DESC_FLD.WORK_ORDER, "작업지시")}
					titleWidth={titleWidth}
				/>
				<input
					className="h-[38px] min-w-0 flex-1 rounded-[8px] border border-[#cbd9eb] bg-white px-[10px] text-[18px]"
					name="productOrderNo"
					value={editKSK2020_R01?.productOrderNo || ""}
					onChange={handleChange}
					onDoubleClick={getProductWorkFieldHandlers('productOrderNo').onDoubleClick}
					onKeyDown={getProductWorkFieldHandlers('productOrderNo').onEnterKeyDown}
				/>
			</label>
            
            <button 
				className="flex h-[38px] w-[44px] shrink-0 items-center justify-center rounded-[8px] border border-[#cbd9eb] bg-[#f7f9fc] text-[#365985] hover:bg-[#e8eff8]"
				onClick={() => {
					setSearchTrigger(true);
				}}
				title={renderDescText(DESC_BTN.FETCH, "조회")}
			>
				<SearchOutlined />
			</button>
        </div>
    );
}
